module.exports = __webpack_public_path__ + "static/media/operational-excellence-icon_2-color.9963cfe0.svg";